import Card from "@material-ui/core/Card/Card";
import CardHeader from "@material-ui/core/CardHeader/index";
import CardContent from "@material-ui/core/CardContent/index";
import Grid from "@material-ui/core/Grid/index";
import React from "react";
import logo from '../../../assetImages/undraw_cloud_files_wmo8.svg';

class GetStartedDesktopAppDownloadWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {appStyle} = this.props;

        return (
            <Grid item xs={12} sm={6} md={4}>
                <Card className={appStyle.getStartedCard} >
                    <CardHeader
                        title='2. Get Desktop App'
                        subheader='Microsoft Store'
                        titleTypographyProps={{align: 'center'}}
                        subheaderTypographyProps={{align: 'center'}}
                        action={null}
                        className={appStyle.getStartedCardHeader}
                    />
                    <CardContent>
                        <a href="https://www.microsoft.com/store/apps/9PP1DXSC054F" target="_blank">
                            <div className={appStyle.imgbox}>
                                <img className={appStyle.centerFit} src={logo}/>
                            </div>
                        </a>
                    </CardContent>
                </Card>
            </Grid>
        );
    }
}
export default GetStartedDesktopAppDownloadWidget;